// extracted by mini-css-extract-plugin
module.exports = {"privacyPolicy":"PrivacyPolicy_privacyPolicy__ou4F9"};